# GraphQL fragment to delete a goal within the sales automation environment.

mutation DeleteGoal($goal: DeleteGoalInputFieldInput!) {
    deleteGoal(input: {goal: $goal}) {
        goal {
            id
        }
    }
}
